import { render, staticRenderFns } from "./ShiftsSchedule.vue?vue&type=template&id=9a331000&"
import script from "./ShiftsSchedule.vue?vue&type=script&lang=js&"
export * from "./ShiftsSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports